import { useState } from "react";
import { Flame, Gauge, Snowflake, Sparkles } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const STYLES = {
  hot: { bg: "bg-acid", Icon: Flame, label: "Hot lead" },
  warm: { bg: "bg-white", Icon: Gauge, label: "Warm lead" },
  cold: { bg: "bg-bone", Icon: Snowflake, label: "Cold lead" },
};

/** Claude's lead-quality score. Scores itself on demand for older jobs. */
export default function LeadScoreBadge({ job }) {
  const [score, setScore] = useState(
    job.ai_score == null ? null : { score: job.ai_score, label: job.ai_score_label, summary: job.ai_score_summary, reasons: job.ai_score_reasons || [] }
  );
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);

  const rate = async () => {
    setBusy(true);
    try {
      const r = await api.post(`/ai/lead-score/${job.job_id}`);
      setScore(r.data);
      setOpen(true);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Scoring unavailable");
    } finally {
      setBusy(false);
    }
  };

  if (!score) {
    return (
      <button onClick={rate} disabled={busy} className="overline border-2 border-ink px-2 py-1 bg-white hover:bg-acid disabled:opacity-40" data-testid={`score-rate-${job.job_id}`}>
        <Sparkles className="w-3 h-3 inline mr-1" />{busy ? "Scoring..." : "AI score"}
      </button>
    );
  }

  const s = STYLES[score.label] || STYLES.warm;
  return (
    <div className="relative">
      <button onClick={() => setOpen(!open)} className={`overline border-2 border-ink px-2 py-1 ${s.bg}`} data-testid={`score-badge-${job.job_id}`}>
        <s.Icon className="w-3 h-3 inline mr-1" />{score.score}/100 · {score.label}
      </button>
      {open && (
        <div className="absolute z-20 mt-2 w-72 brut-card bg-white p-4 text-left" data-testid={`score-detail-${job.job_id}`}>
          <div className="overline">// {s.label} · Claude</div>
          {score.summary && <p className="text-sm mt-2">{score.summary}</p>}
          <ul className="mt-3 space-y-1">
            {(score.reasons || []).map((r) => (
              <li key={r} className="font-mono text-[10px] leading-relaxed">— {r}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
